import { render, staticRenderFns } from "./SupplierFoodSaleOriginal.vue?vue&type=template&id=efd0b964&"
import script from "./SupplierFoodSaleOriginal.vue?vue&type=script&lang=js&"
export * from "./SupplierFoodSaleOriginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports